module.exports = __webpack_public_path__ + "img/電気回路_6_6_1.69e7b061.png";